import React from 'react';
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import * as CONSTANTS from "../../../StringConstants.js"

function TLHSidebar() {
  return (
    <div style={{
      width: '260px',
      height: '100vh',
      overflowY: 'auto',
      overflowX: 'hidden',
      background: '#f4f4f4',
      borderRight: '1px solid #ddd',
    }}>
      <List>
        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.TLHStaffDashboard}>
            <ListItemText primary="Main Dashboard" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.TakeNewEnquiry}>
            <ListItemText primary="New Enquiry / Assessment" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.ViewOpenEnquiries}>
            <ListItemText primary="Current Open Enquiries" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.ViewBookedAssessments}>
            <ListItemText primary="Booked Assessments" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.ViewTLHClasses}>
            <ListItemText primary="TLH Classes" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.OneToOnes}>
            <ListItemText primary="One to Ones" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.TLHParentEvenings}>
            <ListItemText primary="Prospective Parents Evening" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.ViewPrintedInventory}>
            <ListItemText primary="Lesson Plans" />
          </ListItemButton>
        </ListItem>

        <ListItem>
          <ListItemButton component={Link} to={CONSTANTS.OldStudents}>
            <ListItemText primary="Old Students" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );
}

export default TLHSidebar;
